import { ConfigService } from '../../config/config.service';
import { DOCUMENT, NgClass } from '@angular/common';
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import {
  LanguageService,
  RightSidebarService,
  InConfiguration,
  Role,
  AuthService,
} from '@core';
import { FeatherIconsComponent } from '@shared/components/feather-icons/feather-icons.component';
import { NgScrollbar } from 'ngx-scrollbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { SignalrService } from '@core/service/signalr.service';
import {
  NotificationDataModel,
  NotificationModel,
  NotificationPaginatedResVm,
  NotificationPaginatedVm,
} from '@core/models/NotificationModel';
import { ToastrService } from 'ngx-toastr';
import { HelpInquiry } from 'app/home/help-inquiry/models/help-inquiry.model';
import { HelpersService } from '@shared/services/helpers.service';
import { NotificationDataService } from '@shared/services/notification-data.service';
import { takeUntil } from 'rxjs';
import { UsersService } from 'app/home/users/services/users.service';
import { CommonSharedService } from '@shared/services/common-shared.service';
import { TwofaModalComponent } from '../../shared/components/twofa-modal/twofa-modal.component';
import { TwfacodeModalComponent } from '../../shared/components/twfacode-modal/twfacode-modal.component';
import { ProductsRequestService } from 'app/home/assign-products-request/services/products-request.service';
import { Constants } from '@shared/models/constants';
import Swal from 'sweetalert2';
interface Notifications {
  message: string;
  time: string;
  icon: string;
  color: string;
  status: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    NgClass,
    MatButtonModule,
    MatMenuModule,
    NgScrollbar,
    FeatherIconsComponent,
    TwofaModalComponent,
    TwfacodeModalComponent,
  ],
})
export class HeaderComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  public config!: InConfiguration;
  userImg?: string;
  homePage?: string = 'dashboard';
  isNavbarCollapsed = true;
  flagvalue: string | string[] | undefined;
  countryName: string | string[] = [];
  langStoreValue?: string;
  defaultFlag?: string;
  isOpenSidebar?: boolean;
  docElement?: HTMLElement;
  isFullScreen = false;
  userName: string = '';
  notificationList: NotificationDataModel[] = [];
  notificationTotalItemCount: any;
  isLoading: boolean = false;
  unreadCount: number = 0;
  notificationPaginatedVm?: NotificationPaginatedVm;
  page: number = 1;
  showAllUnreadNotifications: boolean = false;
  isProductReqEnabled: boolean = false;
  notificationIconHidden: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private rightSidebarService: RightSidebarService,
    private configService: ConfigService,
    private authService: AuthService,
    private router: Router,
    public languageService: LanguageService,
    private signalrService: SignalrService,
    private toastr: ToastrService,
    private helperService: HelpersService,
    private notificationService: NotificationDataService,
    private userService: UsersService,
    private commonSharedService: CommonSharedService,
    private productRequestService: ProductsRequestService
  ) {
    super();
  }
  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.svg', lang: 'en' },
    // { text: 'Spanish', flag: 'assets/images/flags/spain.svg', lang: 'es' },
    // { text: 'German', flag: 'assets/images/flags/germany.svg', lang: 'de' },
  ];
  notifications: Notifications[] = [
    {
      message: 'Please check your mail',
      time: '14 mins ago',
      icon: 'mail',
      color: 'nfc-green',
      status: 'msg-unread',
    },
    {
      message: 'New Patient Added..',
      time: '22 mins ago',
      icon: 'person_add',
      color: 'nfc-blue',
      status: 'msg-read',
    },
    {
      message: 'Your leave is approved!! ',
      time: '3 hours ago',
      icon: 'event_available',
      color: 'nfc-orange',
      status: 'msg-read',
    },
    {
      message: 'Lets break for lunch...',
      time: '5 hours ago',
      icon: 'lunch_dining',
      color: 'nfc-blue',
      status: 'msg-read',
    },
    {
      message: 'Patient report generated',
      time: '14 mins ago',
      icon: 'description',
      color: 'nfc-green',
      status: 'msg-read',
    },
    {
      message: 'Please check your mail',
      time: '22 mins ago',
      icon: 'mail',
      color: 'nfc-red',
      status: 'msg-read',
    },
    {
      message: 'Salary credited...',
      time: '3 hours ago',
      icon: 'paid',
      color: 'nfc-purple',
      status: 'msg-read',
    },
  ];
  ngOnInit() {
    this.config = this.configService.configData;

    const userRole = this.authService.currentUserValue.role;
    this.userImg = this.authService.currentUserValue.img;
    this.userName =
      this.authService.currentUserValue.firstName +
      ' ' +
      this.authService.currentUserValue.lastName;
    this.docElement = document.documentElement;

    this.langStoreValue = localStorage.getItem('lang') as string;
    const val = this.listLang.filter((x) => x.lang === this.langStoreValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.defaultFlag = 'assets/images/flags/us.svg';
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }
    this.getConfigurationData();
    this.checkProductReqEnable();
    this.hideNotificationIcon();
    
  }
  callFullscreen() {
    if (!this.isFullScreen) {
      if (this.docElement?.requestFullscreen != null) {
        this.docElement?.requestFullscreen();
      }
    } else {
      document.exitFullscreen();
    }
    this.isFullScreen = !this.isFullScreen;
  }
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.langStoreValue = lang;
    this.languageService.setLanguage(lang);
  }
  mobileMenuSidebarOpen(event: Event, className: string) {
    const hasClass = (event.target as HTMLInputElement).classList.contains(
      className
    );
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains('side-closed');
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
      localStorage.setItem('collapsed_menu', 'false');
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
      localStorage.setItem('collapsed_menu', 'true');
    }
  }
  get isSidebarCollapsed(): boolean {
    return this.document.body.classList.contains('side-closed') &&
      this.document.body.classList.contains('submenu-closed');
  }

  logout() {
     Swal.fire({
      title: 'Logout?',
      text: "Do you want to logout?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#e0272a',
      cancelButtonColor: 'transparent',
      cancelButtonText: "Cancel",
      confirmButtonText: "Logout",
    }).then((result) => {
      if (result.isConfirmed) {
        this.subs.sink = this.authService.logout().subscribe((res) => {});
      }
    })
  }

  notificationInit() {
    this.signalrService.connect();

    this.signalrService
      .getMessageObservable()
      .subscribe((message: NotificationModel) => {
        // this.notificationModel = message

        if (message.userId == this.authService.currentUserValue.id) {
          if (message.type === 'USERLOGOUT') {
            this.toastr.error(message.notification);
            this.logout();
          } else {
            this.page = 1;
            this.getunreadCount();
            this.getNotifications();
            this.toastr.info(message.notification, message.title ?? '', {
              timeOut: 5000,
              closeButton: true,
              tapToDismiss: false,
            });
          }
        } else if (message.userId == 'ADMIN') {
          this.page = 1;
          this.getunreadCount();
          this.getNotifications();

          this.toastr.info(message.notification, message.title ?? '', {
            timeOut: 5000,
            closeButton: true,
            tapToDismiss: false,
          });
        }
      });
  }
  onScroll(event: Event): void {
    const element = event.target as HTMLElement;
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      // User has scrolled to the bottom
      if (this.notificationList.length == this.page * 10) {
        this.page++;
        this.getNotifications();
      }
      // Perform actions as needed
    }
  }

  markAllNoficationsAsRead() {
    this.notificationService.markAllAsRead().subscribe((res: boolean) => {
      this.showAllUnreadNotifications = res;
      this.unreadCount = 0;
      this.notificationList = this.notificationList.map((notification) => ({
        ...notification,
        isRead: true,
      }));
    });
  }

  bellClick() { }

  getFromNow(dateInUtc: any) {
    return this.helperService.getDateFromDb(dateInUtc).fromNow(true);
  }

  handleNotification(notification: NotificationDataModel) {
    console.log(notification, 'notification');

    this.notificationService
      .markAsReadById(notification.id)
      .subscribe((res: boolean) => {
        if (res) {
          this.page = 1;
          this.getNotifications();

          if (notification.type == 'PRODUCT_REQUEST') {


            if (notification.referenceId && notification.referenceId.length > 0) {
              this.isLoading = true;
              this.productRequestService.getAssignProductById(notification.referenceId).subscribe((res) => {
                if (res) {

                  this.handleProductRequest(res.status);
                  this.isLoading = false;
                }
              });

            } else {
              this.handleProductRequest(notification.reference);
            }

          }
        }
      });
  }

  getunreadCount() {
    this.notificationService.getUnreadCount().subscribe((res) => {
      this.unreadCount = res ?? 0;
    });
  }
  getNotifications() {
    this.notificationPaginatedVm = {
      pageIndex: this.page,
      pageSize: 10,
      searchString: '',
      // userId:this.authService.currentUserValue.id
    };
    this.isLoading = true;
    this.notificationService
      .getNotificationsList(this.notificationPaginatedVm)
      .pipe()
      .subscribe((res: NotificationPaginatedResVm) => {
        this.isLoading = false;
        this.getunreadCount();

        if (this.notificationList.length == 0 || this.page == 1) {
          this.notificationList = res.items;
          this.notificationTotalItemCount = res.totalItemCount;
        } else {
          this.notificationList = [...this.notificationList, ...res.items];
          this.notificationTotalItemCount = res.totalItemCount;
        }
      });
  }
  handleProductRequest(reference: string) {

    var tabIndex = this.getTabIndextoNavigate(reference);
    this.router.navigateByUrl(`product-request?tabIndex=${tabIndex}&&pageIndex=1`);

  }


  getTabIndextoNavigate(reference: string | null) {
    let tabIndex = 0;
    switch (reference) {
      case 'ONGOING':
        tabIndex = 1;
        break;
      case 'COMPLETED':
        tabIndex = 2;
        break;
      case 'REJECTED':
        tabIndex = 3;
        break;
      case null:
        tabIndex = 2;
        break;
    }
    return tabIndex;
  }
  enable2FA() {
    this.commonSharedService.setF2FAModal(true);
  }

  truncateText(text: string, maxLength: number): string {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength) + '...';
  }

  getConfigurationData() {
    this.configService.getConfigurationList().subscribe((res) => {
      localStorage.setItem('configData', JSON.stringify(res));
    });
  }

  checkProductReqEnable(){
    let configDataNew = this.helperService.getConfigData('IS_PRODUCT_REQUEST_ENABLE', false);
    this.isProductReqEnabled = configDataNew === "true";
  }

  hideNotificationIcon(){
    if(this.isProductReqEnabled == false)
    {
      this.notificationIconHidden = true;
    } else {
      this.notificationInit();
      this.getNotifications();
      this.notificationIconHidden = false;
    }      
  }
}
